<template>
  <div>
    <div v-show="!loading">
      <v-row :class="$vuetify.breakpoint.smAndDown ? 'align-center justify-center' : ''" style="min-height: 312px">
        <v-col
          cols="12" sm="12" md="9" lg="9"
          :class="$vuetify.breakpoint.smAndDown ? '': 'pa-0 pl-4'"
        >
          <div v-if="index === 0" style="height: 100%">
            <Beneficiario
              ref="beneficiario"
              @editavel="value => editavel = value"
              @success="successPendencia"
              @gerouPendencia="controlaPendencia"
              @pendente="controlaPendente"
              @error="launchError"
              :editProp="(!editavel && !canEditBeneficiarios) || !edit"
              v-model="loading"
            />
          </div>
          <div v-if="index === 1" style="height: 100%">
            <Cooperado
              ref="cooperado"
              @editavel="value => editavel = value"
              @success="successPendencia"
              @gerouPendencia="controlaPendencia"
              @pendente="controlaPendente"
              @error="launchError"
              :editProp="(!editavel && !canEdit) || !edit"
              v-model="loading"
            />
          </div>
          <div v-if="index === 2" style="height: 92%">
            <Colaborador
              ref="colaborador"
              @editavel="value => editavel = value"
              @success="successPendencia"
              @gerouPendencia="controlaPendencia"
              @pendente="controlaPendente"
              @error="launchError"
              :editProp="(!editavel && !canEdit) || !edit"
              v-model="loading"
            />
          </div>
        </v-col>
        <v-col cols="3" class="pa-0 pt-6" v-if="!$vuetify.breakpoint.smAndDown">
          <v-row justify="center">
            <v-col cols="auto">
              <button-cadu text="COMPETÊNCIAS" @click="gerenciaComponente
              "/>
            </v-col>
          </v-row>
          <v-row justify="center" style="height: 92%">
            <v-col cols="auto">
              <button-cadu 
              :width="190" iconName="upload-cloud" 
              v-if="this.permiteAtualizarCompetenciaCadbenef && this.index  === 0 && this.role === 'admin_brasil'"
              :iconSize="18"
              :loading="loadingCadBenef" text="ATUALIZAR CADBENEF" 
              @click="consultarCompetenciaCadbenef()"/>
            </v-col>
          </v-row>

          <v-row justify="center" class="pb-4" v-if="edit">
            <v-col cols="auto">
              <button-cadu :disabled="emptyArray || !editavel|| !edit" text="SALVAR" @click="salvaComponente"/>
            </v-col>
          </v-row>

          <v-row justify="center" class="pb-4" v-else>
            <v-col cols="12" v-if="edit">
              <button-cadu block text="COMPETÊNCIAS" @click="gerenciaComponente"/>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <v-row justify="end" align="end" v-if="edit && this.showButtonReenviarComErro">
        <v-col cols="12" sm="auto">
          <button-cadu
            :width="190"
            text="REENVIAR COM ERRO"
            :block="$vuetify.breakpoint.xs"
            :loading="loadingErro"
            @click="reenviarComErro"
            :backColor="$vuetify.theme.themes.light.primary2"
          />
        </v-col>
    </v-row>
      <ModalCompetencia ref="modalCompetencia" :type="index" v-model="show"/>
    </div>
    <component-loading style="height: 256px;" :value="loading"/>
    <overlay-loading :value="loadingOverlay"/>

    <SucessoModal
      :showSucess="showSuccess"
      :genericMessage="genericMessage"
      :width="560"
      @close="resetSuccess"
    />

    <SucessoModal
      :showSucess="showSuccessCadbenef"
      :genericMessage="genericMessage"
      :width="560"
      @close="resetSuccessCadbenef"
    />
    <error-modal
      v-model="error"
      :errObj="errObj"
    />
    <ModalPendencia
      v-model="showPendencia"
      :mensagem="mensagemPendencia"
      @input="resetPendencia"
      @salvarPendencia="justificativa => salvaComponente(justificativa)"
    />
    <ModalPendente
      v-model="showPendente"
      :objPendente="objPendente"
    />
  </div>
</template>

<script>
import Beneficiario from './Right/Beneficiario'
import Cooperado from './Right/Cooperado'
import jwtDecode from 'jwt-decode'
import Colaborador from './Right/Colaborador'
import ModalCompetencia from './Right/Shared/Competencia/ModalCompetencia'
import ModalPendente from './Right/Shared/ModalPendente'
import { EventBus } from '@/services/EventBus/EventBus'

const ModalPendencia = () => import(
  /* webpackChunkName: "ModalPendencia" */ './Right/Shared/ModalPendencia'
)

export default {
  components: {
    Beneficiario,
    Cooperado,
    Colaborador,
    ModalCompetencia,
    ModalPendencia,
    ModalPendente
  },
  props: {
    index: {
      type: Number,
      required: true
    }
  },
  data () {
    return {
      show: false,
      loading: false,
      loadingOverlay: false,
      loadingErro: false,
      editavel: false,
      showSuccess: false,
      permiteAtualizarCompetenciaCadbenef: false,
      type: 'edit',
      error: false,
      errObj: {},
      message: `Quantidade de ${this.getMessage}`,
      emptyArray: false,
      role: '',
      edit: JSON.parse(localStorage.getItem('optionEdit')),
      mensagemPendencia: '',
      gerouPendencia: false,
      showPendencia: false,
      showPendente: false,
      loadingCadBenef: false,
      showSuccessCadbenef: false,
      showButtonReenviarComErro: false,
      genericMessage: `Quantidade de ${this.getMessage} atualizada com sucesso!`,
      objPendente: {
        mesPendente: '',
        subMenu: ''
      },
      modalSave: false
    }
  },
  beforeMount () {
    this.tokenBearer = localStorage.getItem('tokenBearer')
    let decoded = jwtDecode(this.tokenBearer)
    this.role = decoded.role;
    EventBus.$on('pendenteModal', (obj) => {
      this.modalSave = true
      this.controlaPendencia(obj)
    });

    EventBus.$on('atualizacaoCadbenefPerfil', (loadingObj) => {
      this.loadingCadBenef = loadingObj.loading;
      this.loadingErro = loadingObj.loadingError;
    });

    EventBus.$on('permiteAtualizarCadbenef', (status) => {
      this.permiteAtualizarCompetenciaCadbenef = status;
    })

  },
  computed: {
    getMessage () {
      return this.index === 0 ? 'beneficiários ' : (this.index === 1 ? 'cooperados ' : 'colaboradores ')
    },
    canSave () {
      return this.role !== 'colaborador' || this.role !== 'colaborador_brasil'
    },
    canEdit () {
      return this.role === 'admin_brasil' || this.role === 'admin' || this.role === 'dirigente'
    },
    canEditBeneficiarios () {
      return this.role === 'admin_brasil'
    }
  },
  methods: {
    controlaPendente (mes) {
      this.objPendente.mesPendente = mes
      this.objPendente.subMenu = this.getMessage
      this.showPendente = true
    },
    successPendencia (objSuccess) {
      if (!objSuccess) {
        this.showPendencia = false
        this.showSuccess = true;
      } else {
        if (objSuccess.origin !== undefined && objSuccess.origin === "atualizacaoCadbenef") {
          this.loadingCadBenef = false;
          this.showSuccessCadbenef = true;
          this.genericMessage = objSuccess.message;
        } else if (!!objSuccess.origin && !!objSuccess.message) {
          this.loadingCadBenef = false;
          this.loading = false;
          this.showSuccess = true; 
          this.genericMessage = objSuccess.message;
        }
      }
    },
    controlaPendencia (obj) {
      this.showPendencia = true
      this.gerouPendencia = obj.gerouPendencia
      this.mensagemPendencia = obj.mensagem
    },
    validarMudanca () {
      switch (this.index) {
        case 0:
          this.$refs.beneficiario.validarMudanca()
          break
        case 1:
          this.$refs.cooperado.validarMudanca()
          break
        case 2:
          this.$refs.colaborador.validarMudanca()
          break
        default:
          break
      }
    },
    resetSuccess () {
      this.showSuccess = false
      this.resetStep()
    },
    resetSuccessCadbenef () {
      this.showSuccessCadbenef = false;
      // this.resetStep();
      // atualiza a tela 
      // EventBus.$emit('changeAbaMinhaUnimed', {tab: 'perfil', tabIndex: 2});

    },
    resetPendencia () {
      this.showPendencia = false
    },
    resetStep () {
      if (!this.modalSave) {
        switch (this.index) {
          case 0:
            this.loading = true
            this.$refs.beneficiario.loadBenefiario()
            this.loading = false
            break
          case 1:
            this.loading = true
            this.$refs.cooperado.getCooperado()
            this.loading = false
            break
          case 2:
            this.loading = true
            this.$refs.colaborador.getColaborador()
            this.loading = false
            break
          default:
            break
        }
      }
    },
    launchError (err) {
      this.loadingCadBenef = false;
      this.showPendencia = false;
      this.loadingErro = false;
      this.showButtonReenviarComErro = false;
      this.error = true;
      if (err.response && err.response.data) {
        this.errObj.status = err.response.status;
        this.errObj.error = err.response.data.message;
      } else if (err.data) {
        this.errObj.status = err.data.status;
        this.errObj.error = err.data.message;
      }

      if (err.origin === "atualizacaoCadbenef") {
        this.showButtonReenviarComErro = true;
      }    
      console.error(err);    
    },
    gerenciaComponente () {
      this.show = !this.show
      this.$refs.modalCompetencia.start()
    },
    async consultarCompetenciaCadbenef() {
      this.loadingCadBenef = true;
      this.$refs.beneficiario.consultarCompetenciaCadbenef(false);
    },
    async reenviarComErro() {
      this.$refs.beneficiario.consultarCompetenciaCadbenef(true);
    },
    async salvaComponente (justificativa) {

      if (justificativa) {
        this.showPendencia = false;
      }

      if (this.modalSave) {
        this.showPendencia = false
        this.$refs.modalCompetencia.editarPerfil(justificativa)
      } else {
        switch (this.index) {
          case 0:
            this.loadingOverlay = true
            await this.$refs.beneficiario.putBeneficiario(justificativa)
            this.loadingOverlay = false
            break
          case 1:
            this.loadingOverlay = true
            await this.$refs.cooperado.putCooperado(justificativa)
            this.loadingOverlay = false
            break
          case 2:
            this.loadingOverlay = true
            await this.$refs.colaborador.putColaborador(justificativa)
            this.loadingOverlay = false
            break
          default:
            break
        }
      }
    }
  }
}
</script>
